import { withPublicWrapper } from '../components/public/Wrapper/withPublicWrapper';
import Intro from 'components/public/Intro/Intro';
import React from 'react';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { Col, Divider } from 'antd';
import ContactForm from 'components/ContactForm';

const DataRequest = (): JSX.Element => {
  return (
    <>
      <Intro
        title="Data Request"
        image={{ src: '/logo.png', alt: 'logo', width: '1779', height: '1608' }}
        descriptionText="Own your own data"
      />
      <IntroBlock
        type="white"
        description={
          <Col>
            <p>We are not doing anything with your personal data.</p>
            <p>
              But we need to keep some of the data regarding your active integrations, to be able to
              serve your needs.
            </p>
            <p>You want to know which data we have from you?</p>
            <Divider orientation="center">Contact us, and we will provide you with a</Divider>
            <ContactForm withoutApps />
          </Col>
        }
      />
    </>
  );
};

export default withPublicWrapper(DataRequest);
